import React, { useMemo } from 'react';
import styles from './Advt.module.css';

import { useGetParams } from '../../hooks/useGetParams';
import { iconsSources } from '../../helpers/icons';
import hum from '../../assets/images/channel-none.png';
import logo from '../../assets/images/logo.png';

const Advt = React.memo(() => {
  const { qrCode, socials, phoneNumber, paddingQR } = useGetParams();

  const advtInfo = useMemo(
    () => ({
      qrCode: qrCode,
      number: phoneNumber,
      socials: socials?.split(','),
    }),
    [phoneNumber, socials, qrCode]
  );

  let format = advtInfo.number ? '+7 xxx xxx-xx-xx' : '';
  if (advtInfo.number) {
    if (!advtInfo.number.includes('-') && !advtInfo.number.includes('+7')) {
      for (let i = 0; i < advtInfo.number.length; i++) {
        format = format.replace('x', advtInfo.number[i]);
      }
    } else if (
      advtInfo.number.includes('+7') &&
      !advtInfo.number.includes('-')
    ) {
      for (let i = 2; i < advtInfo.number.length; i++) {
        format = format.replace('x', advtInfo.number[i]);
      }
    } else {
      format = advtInfo.number;
    }
  }

  return (
    <>
      <div className={styles.advtBlock}>
        <div className={styles.logo}>
          <img src={logo} alt="Logo" />
        </div>
        {phoneNumber && <div className={styles.phone}>{format}</div>}

        <div className={styles.qrBlock}>
          {advtInfo.socials && (
            <div className={styles.socials}>
              {advtInfo.socials.map((el) => (
                <div key={el} className={styles.advtIcon}>
                  <img src={iconsSources[el] || hum} alt="Social" />
                </div>
              ))}
            </div>
          )}
          {qrCode && (
            <div
              className={styles.qr} // изменения на случай QR кода с белой рамкой
              style={{
                padding: `${
                  Number(paddingQR) + 2
                }rem ${paddingQR}rem ${paddingQR}rem`,
              }}>
              <img src={qrCode} alt="QR" />
            </div>
          )}
        </div>
      </div>
    </>
  );
});

export default Advt;
